import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { LoginPortal } from './LoginPortal';
import AuthCallback from './AuthCallback';
import { RootRedirect } from './RootRedirect';
import { validateAndCleanToken, scheduleTokenRefresh } from './authUtils';
import { AppShell } from './components/AppShell';
import { OrgTypeRoute } from './components/OrgTypeRoute';
import { ProtectedRoute } from './components/ProtectedRoute';
import IntegrationsPage from './pages/IntegrationsPage';
import IntegrationDetailsPage from './pages/IntegrationDetailsPage';
import FieldMappingConfigPage from './pages/FieldMappingConfigPage';
import { ReferralListPage } from './pages/carrier-portal/ReferralListPage';
import { ClosedReferralListPage } from './pages/carrier-portal/ClosedReferralListPage';
import { CarrierEngagementDashboardPage } from './pages/carrier-engagement/CarrierEngagementDashboardPage';
import { ToastProvider } from './components/ui/Toast';

function App() {
  // Validate and clean up expired tokens on app initialization,
  // then start the proactive refresh timer so the token is renewed
  // before it expires (prevents mid-session logouts).
  useEffect(() => {
    if (validateAndCleanToken()) {
      scheduleTokenRefresh();
    }
  }, []);

  return (
    <ToastProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPortal />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Protected routes with AppShell layout - Internal employees only */}
            <Route element={<AppShell />}>
              <Route path="/integrations" element={
                <ProtectedRoute>
                  <IntegrationsPage />
                </ProtectedRoute>
              } />
              <Route path="/integrations/:clientId" element={
                <ProtectedRoute>
                  <IntegrationDetailsPage />
                </ProtectedRoute>
              } />
              <Route path="/integrations/:integrationId/revisions/:revisionId/config" element={
                <ProtectedRoute>
                  <FieldMappingConfigPage />
                </ProtectedRoute>
              } />
              <Route path="/referrals" element={
                // Accessible to external users (CARRIER, CLIENT, TPA) and INTERNAL employees
                <OrgTypeRoute allowedOrgTypes={['CARRIER', 'CLIENT', 'INTERNAL', 'TPA']}>
                  <ReferralListPage />
                </OrgTypeRoute>
              } />
              <Route path="/closed-referrals" element={
                // Accessible to external users (CARRIER, CLIENT, TPA) and INTERNAL employees
                <OrgTypeRoute allowedOrgTypes={['CARRIER', 'CLIENT', 'INTERNAL', 'TPA']}>
                  <ClosedReferralListPage />
                </OrgTypeRoute>
              } />
              <Route path="/carrier-engagement-dashboard" element={
                <OrgTypeRoute allowedOrgTypes={['INTERNAL']}>
                  <CarrierEngagementDashboardPage />
                </OrgTypeRoute>
              } />
            </Route>

            {/* Root path - check for token and redirect appropriately */}
            <Route path="/" element={<RootRedirect />} />
          </Routes>
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
